export const FILTER_OPTIONS = [
  {
    value: "matched",
    label: "Matched (first submission)",
  },
  {
    value: "matching",
    label: "Matching (trigger submission)",
  },
  {
    value: "own_journals",
    label: "Own journals",
  },
  {
    value: "with_other_publisher",
    label: "With other publisher",
  },
];

export const DEFAULT_FILTER_VALUES = FILTER_OPTIONS.reduce(
  (acc, { value }) => ({ ...acc, [value]: true }),
  {}
);

export const filterSelectionToString = (selection) =>
  Object.entries(selection)
    .filter(([, isSelected]) => isSelected)
    .map(([key]) => key)
    .join(",");
